module.exports = __webpack_public_path__ + "static/media/Thumbnail-Ultradent-RDH-Kristin.d6884c82.png";